export const statusMap = {
  0: "Harvested",
  1: "Processed",
  2: "Packed",
  3: "ForSale",
  4: "Sold",
  5: "Shipped",
  6: "Received",
  7: "Purchased",
}
